import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { Card, CardContent, CardHeader, Stack } from '@packages/shared';
import { useIntl } from 'react-intl';
import { EcoLabelCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/EcoLabelCardFragmentFragmentDoc';
import { EcoLabelItem } from '../EcoLabelItem';
import { EcoLabelCardMessages } from './messages';

/* GraphQL */ `
  fragment EcoLabelCardFragment on Product {
    ecoLabels {
      ...EcoLabelItemFragment
    }
  }
`;

export type EcoLabelCardProps = {
  ecoLabelsData: FragmentType<typeof EcoLabelCardFragmentFragmentDoc>;
};

/**
 * <p>This component renders all eco-labels of a product.</p>
 * <i>A product can have multiple eco-labels.</i>
 * */
export const EcoLabelCard = ({ ecoLabelsData }: EcoLabelCardProps) => {
  const { formatMessage } = useIntl();
  const { ecoLabels } = getFragmentData(EcoLabelCardFragmentFragmentDoc, ecoLabelsData);

  if (ecoLabels.length === 0) return null;

  return (
    <Card>
      <CardHeader
        title={formatMessage(EcoLabelCardMessages.DialogHeadline)}
        sx={{
          borderBottom: 1,
          borderColor: 'grey.main',
          py: 1,
          px: 2,
        }}
      />
      <CardContent>
        <Stack gap={1.5}>
          {ecoLabels.map((ecoLabel, idx) => (
            <EcoLabelItem
              // is disabled because this list is not being reordered
              // eslint-disable-next-line react/no-array-index-key
              key={idx}
              ecoLabelData={ecoLabel}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
